import ParImg1 from "../../assets/partner1.jpg";
import ParImg2 from "../../assets/partner2.png";
import ParImg3 from "../../assets/partner3.png";
import ParImg4 from "../../assets/partner4.jpg";
import ParImg5 from "../../assets/partner5.jpg";
import ParImg6 from "../../assets/partner6.jpg";
import ParImg7 from "../../assets/partner7.jpg";
import ParImg8 from "../../assets/partner8.png";
import ParImg10 from "../../assets/partner10.jpg";
import ParImg11 from "../../assets/partner11.jpg";
import ParImg12 from "../../assets/partner12.png";
import ParImg13 from "../../assets/partner13.jpg";
import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Slider.css";
import { baseUrl } from "../../config";

const slides = [
  [ParImg1, ParImg2, ParImg3, ParImg4],
  [ParImg5, ParImg6, ParImg7, ParImg8],
  [ParImg13, ParImg11, ParImg10, ParImg12],
];

export default function Slider() {
  return (
    <div className="skyua-partner-slider">
      <Carousel
        className="skyua-partner-carousel"
        interval={null}
        touch
        prevIcon={
          <span className="skyua-partner-arrow" aria-hidden="true">
            <img src={baseUrl + "/sliderPrev.png"} alt="" />
          </span>
        }
        nextIcon={
          <span className="skyua-partner-arrow" aria-hidden="true">
            <img src={baseUrl + "/slideNext.png"} alt="" />
          </span>
        }
      >
        {slides.map((slide, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <div className="skyua-partner-grid">
              {slide.map((logo, index) => (
                <div
                  className="skyua-partner-card"
                  key={`${slideIndex}-${index}`}
                >
                  <img src={logo} alt="partner" />
                </div>
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
